export interface PopupPosition {
  top: number;
  left: number;
}

export const calculatePopupPosition = (event: Event): PopupPosition => {
  const clickedFile = (event.target as HTMLElement).getBoundingClientRect();
  const fileHandlerComponent = (event.target as HTMLElement).closest(
    'app-file-handler',
  ) as HTMLElement;
  //This is a static value as it is very complicated to calculate the dynamic value of the popup
  const popupHeight = 132;

  if (!fileHandlerComponent) {
    return { top: 0, left: 0 };
  }

  const fileHandlerComponentRect = fileHandlerComponent.getBoundingClientRect();

  return {
    top: clickedFile.bottom - fileHandlerComponentRect.top - popupHeight,
    left: clickedFile.left - fileHandlerComponentRect.left,
  };
};
